/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as NotFoundImport } from './routes/not-found'
import { Route as TestLoginRouteImport } from './routes/test-login/route'
import { Route as StudyGroupRouteImport } from './routes/study-group/route'
import { Route as LogoutRouteImport } from './routes/logout/route'
import { Route as FavoritesRouteImport } from './routes/favorites/route'
import { Route as ChatRoomRouteImport } from './routes/chat-room/route'
import { Route as CallbackRouteImport } from './routes/callback/route'
import { Route as CalendarRouteImport } from './routes/calendar/route'
import { Route as IndexImport } from './routes/index'
import { Route as EventSearchIndexImport } from './routes/event-search/index'
import { Route as ChatRoomIndexImport } from './routes/chat-room/index'
import { Route as AllStudyGroupsIndexImport } from './routes/all-study-groups/index'
import { Route as SettingsPeriodicNotificationImport } from './routes/settings/periodic-notification'
import { Route as SettingsInstantNotificationImport } from './routes/settings/instant-notification'
import { Route as UserProfileUserIdRouteImport } from './routes/user-profile/$user-id/route'
import { Route as StudyGroupStudyGroupIdRouteImport } from './routes/study-group/$study-group-id/route'
import { Route as PublicEventEventCodeRouteImport } from './routes/public-event/$event-code/route'
import { Route as NotificationEntryRouteImport } from './routes/notification/entry/route'
import { Route as EventSearchEventIdRouteImport } from './routes/event-search/$event-id/route'
import { Route as ChatRoomChatRoomIdRouteImport } from './routes/chat-room/$chat-room-id/route'
import { Route as AllStudyGroupsStudyGroupIdRouteImport } from './routes/all-study-groups/$study-group-id/route'
import { Route as StudyGroupStudyGroupIdIndexImport } from './routes/study-group/$study-group-id/index'
import { Route as StudyGroupStudyGroupIdStreamRouteImport } from './routes/study-group/$study-group-id/stream/route'
import { Route as StudyGroupStudyGroupIdLinkListRouteImport } from './routes/study-group/$study-group-id/link-list/route'
import { Route as StudyGroupStudyGroupIdInfoRouteImport } from './routes/study-group/$study-group-id/info/route'
import { Route as StudyGroupStudyGroupIdFilesRouteImport } from './routes/study-group/$study-group-id/files/route'
import { Route as StudyGroupStudyGroupIdEventsRouteImport } from './routes/study-group/$study-group-id/events/route'
import { Route as EventSearchCodeEventCodeRouteImport } from './routes/event-search/code/$event-code/route'
import { Route as StudyGroupStudyGroupIdPostPostIdRouteImport } from './routes/study-group/$study-group-id/post/$post-id/route'

// Create/Update Routes

const NotFoundRoute = NotFoundImport.update({
  id: '/not-found',
  path: '/not-found',
  getParentRoute: () => rootRoute,
} as any)

const TestLoginRouteRoute = TestLoginRouteImport.update({
  id: '/test-login',
  path: '/test-login',
  getParentRoute: () => rootRoute,
} as any)

const StudyGroupRouteRoute = StudyGroupRouteImport.update({
  id: '/study-group',
  path: '/study-group',
  getParentRoute: () => rootRoute,
} as any)

const LogoutRouteRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRoute,
} as any)

const FavoritesRouteRoute = FavoritesRouteImport.update({
  id: '/favorites',
  path: '/favorites',
  getParentRoute: () => rootRoute,
} as any)

const ChatRoomRouteRoute = ChatRoomRouteImport.update({
  id: '/chat-room',
  path: '/chat-room',
  getParentRoute: () => rootRoute,
} as any)

const CallbackRouteRoute = CallbackRouteImport.update({
  id: '/callback',
  path: '/callback',
  getParentRoute: () => rootRoute,
} as any)

const CalendarRouteRoute = CalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const EventSearchIndexRoute = EventSearchIndexImport.update({
  id: '/event-search/',
  path: '/event-search/',
  getParentRoute: () => rootRoute,
} as any)

const ChatRoomIndexRoute = ChatRoomIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ChatRoomRouteRoute,
} as any)

const AllStudyGroupsIndexRoute = AllStudyGroupsIndexImport.update({
  id: '/all-study-groups/',
  path: '/all-study-groups/',
  getParentRoute: () => rootRoute,
} as any)

const SettingsPeriodicNotificationRoute =
  SettingsPeriodicNotificationImport.update({
    id: '/settings/periodic-notification',
    path: '/settings/periodic-notification',
    getParentRoute: () => rootRoute,
  } as any)

const SettingsInstantNotificationRoute =
  SettingsInstantNotificationImport.update({
    id: '/settings/instant-notification',
    path: '/settings/instant-notification',
    getParentRoute: () => rootRoute,
  } as any)

const UserProfileUserIdRouteRoute = UserProfileUserIdRouteImport.update({
  id: '/user-profile/$user-id',
  path: '/user-profile/$user-id',
  getParentRoute: () => rootRoute,
} as any)

const StudyGroupStudyGroupIdRouteRoute =
  StudyGroupStudyGroupIdRouteImport.update({
    id: '/$study-group-id',
    path: '/$study-group-id',
    getParentRoute: () => StudyGroupRouteRoute,
  } as any)

const PublicEventEventCodeRouteRoute = PublicEventEventCodeRouteImport.update({
  id: '/public-event/$event-code',
  path: '/public-event/$event-code',
  getParentRoute: () => rootRoute,
} as any)

const NotificationEntryRouteRoute = NotificationEntryRouteImport.update({
  id: '/notification/entry',
  path: '/notification/entry',
  getParentRoute: () => rootRoute,
} as any)

const EventSearchEventIdRouteRoute = EventSearchEventIdRouteImport.update({
  id: '/event-search/$event-id',
  path: '/event-search/$event-id',
  getParentRoute: () => rootRoute,
} as any)

const ChatRoomChatRoomIdRouteRoute = ChatRoomChatRoomIdRouteImport.update({
  id: '/$chat-room-id',
  path: '/$chat-room-id',
  getParentRoute: () => ChatRoomRouteRoute,
} as any)

const AllStudyGroupsStudyGroupIdRouteRoute =
  AllStudyGroupsStudyGroupIdRouteImport.update({
    id: '/all-study-groups/$study-group-id',
    path: '/all-study-groups/$study-group-id',
    getParentRoute: () => rootRoute,
  } as any)

const StudyGroupStudyGroupIdIndexRoute =
  StudyGroupStudyGroupIdIndexImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => StudyGroupStudyGroupIdRouteRoute,
  } as any)

const StudyGroupStudyGroupIdStreamRouteRoute =
  StudyGroupStudyGroupIdStreamRouteImport.update({
    id: '/stream',
    path: '/stream',
    getParentRoute: () => StudyGroupStudyGroupIdRouteRoute,
  } as any)

const StudyGroupStudyGroupIdLinkListRouteRoute =
  StudyGroupStudyGroupIdLinkListRouteImport.update({
    id: '/link-list',
    path: '/link-list',
    getParentRoute: () => StudyGroupStudyGroupIdRouteRoute,
  } as any)

const StudyGroupStudyGroupIdInfoRouteRoute =
  StudyGroupStudyGroupIdInfoRouteImport.update({
    id: '/info',
    path: '/info',
    getParentRoute: () => StudyGroupStudyGroupIdRouteRoute,
  } as any)

const StudyGroupStudyGroupIdFilesRouteRoute =
  StudyGroupStudyGroupIdFilesRouteImport.update({
    id: '/files',
    path: '/files',
    getParentRoute: () => StudyGroupStudyGroupIdRouteRoute,
  } as any)

const StudyGroupStudyGroupIdEventsRouteRoute =
  StudyGroupStudyGroupIdEventsRouteImport.update({
    id: '/events',
    path: '/events',
    getParentRoute: () => StudyGroupStudyGroupIdRouteRoute,
  } as any)

const EventSearchCodeEventCodeRouteRoute =
  EventSearchCodeEventCodeRouteImport.update({
    id: '/event-search/code/$event-code',
    path: '/event-search/code/$event-code',
    getParentRoute: () => rootRoute,
  } as any)

const StudyGroupStudyGroupIdPostPostIdRouteRoute =
  StudyGroupStudyGroupIdPostPostIdRouteImport.update({
    id: '/post/$post-id',
    path: '/post/$post-id',
    getParentRoute: () => StudyGroupStudyGroupIdRouteRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/calendar': {
      id: '/calendar'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof CalendarRouteImport
      parentRoute: typeof rootRoute
    }
    '/callback': {
      id: '/callback'
      path: '/callback'
      fullPath: '/callback'
      preLoaderRoute: typeof CallbackRouteImport
      parentRoute: typeof rootRoute
    }
    '/chat-room': {
      id: '/chat-room'
      path: '/chat-room'
      fullPath: '/chat-room'
      preLoaderRoute: typeof ChatRoomRouteImport
      parentRoute: typeof rootRoute
    }
    '/favorites': {
      id: '/favorites'
      path: '/favorites'
      fullPath: '/favorites'
      preLoaderRoute: typeof FavoritesRouteImport
      parentRoute: typeof rootRoute
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRoute
    }
    '/study-group': {
      id: '/study-group'
      path: '/study-group'
      fullPath: '/study-group'
      preLoaderRoute: typeof StudyGroupRouteImport
      parentRoute: typeof rootRoute
    }
    '/test-login': {
      id: '/test-login'
      path: '/test-login'
      fullPath: '/test-login'
      preLoaderRoute: typeof TestLoginRouteImport
      parentRoute: typeof rootRoute
    }
    '/not-found': {
      id: '/not-found'
      path: '/not-found'
      fullPath: '/not-found'
      preLoaderRoute: typeof NotFoundImport
      parentRoute: typeof rootRoute
    }
    '/all-study-groups/$study-group-id': {
      id: '/all-study-groups/$study-group-id'
      path: '/all-study-groups/$study-group-id'
      fullPath: '/all-study-groups/$study-group-id'
      preLoaderRoute: typeof AllStudyGroupsStudyGroupIdRouteImport
      parentRoute: typeof rootRoute
    }
    '/chat-room/$chat-room-id': {
      id: '/chat-room/$chat-room-id'
      path: '/$chat-room-id'
      fullPath: '/chat-room/$chat-room-id'
      preLoaderRoute: typeof ChatRoomChatRoomIdRouteImport
      parentRoute: typeof ChatRoomRouteImport
    }
    '/event-search/$event-id': {
      id: '/event-search/$event-id'
      path: '/event-search/$event-id'
      fullPath: '/event-search/$event-id'
      preLoaderRoute: typeof EventSearchEventIdRouteImport
      parentRoute: typeof rootRoute
    }
    '/notification/entry': {
      id: '/notification/entry'
      path: '/notification/entry'
      fullPath: '/notification/entry'
      preLoaderRoute: typeof NotificationEntryRouteImport
      parentRoute: typeof rootRoute
    }
    '/public-event/$event-code': {
      id: '/public-event/$event-code'
      path: '/public-event/$event-code'
      fullPath: '/public-event/$event-code'
      preLoaderRoute: typeof PublicEventEventCodeRouteImport
      parentRoute: typeof rootRoute
    }
    '/study-group/$study-group-id': {
      id: '/study-group/$study-group-id'
      path: '/$study-group-id'
      fullPath: '/study-group/$study-group-id'
      preLoaderRoute: typeof StudyGroupStudyGroupIdRouteImport
      parentRoute: typeof StudyGroupRouteImport
    }
    '/user-profile/$user-id': {
      id: '/user-profile/$user-id'
      path: '/user-profile/$user-id'
      fullPath: '/user-profile/$user-id'
      preLoaderRoute: typeof UserProfileUserIdRouteImport
      parentRoute: typeof rootRoute
    }
    '/settings/instant-notification': {
      id: '/settings/instant-notification'
      path: '/settings/instant-notification'
      fullPath: '/settings/instant-notification'
      preLoaderRoute: typeof SettingsInstantNotificationImport
      parentRoute: typeof rootRoute
    }
    '/settings/periodic-notification': {
      id: '/settings/periodic-notification'
      path: '/settings/periodic-notification'
      fullPath: '/settings/periodic-notification'
      preLoaderRoute: typeof SettingsPeriodicNotificationImport
      parentRoute: typeof rootRoute
    }
    '/all-study-groups/': {
      id: '/all-study-groups/'
      path: '/all-study-groups'
      fullPath: '/all-study-groups'
      preLoaderRoute: typeof AllStudyGroupsIndexImport
      parentRoute: typeof rootRoute
    }
    '/chat-room/': {
      id: '/chat-room/'
      path: '/'
      fullPath: '/chat-room/'
      preLoaderRoute: typeof ChatRoomIndexImport
      parentRoute: typeof ChatRoomRouteImport
    }
    '/event-search/': {
      id: '/event-search/'
      path: '/event-search'
      fullPath: '/event-search'
      preLoaderRoute: typeof EventSearchIndexImport
      parentRoute: typeof rootRoute
    }
    '/event-search/code/$event-code': {
      id: '/event-search/code/$event-code'
      path: '/event-search/code/$event-code'
      fullPath: '/event-search/code/$event-code'
      preLoaderRoute: typeof EventSearchCodeEventCodeRouteImport
      parentRoute: typeof rootRoute
    }
    '/study-group/$study-group-id/events': {
      id: '/study-group/$study-group-id/events'
      path: '/events'
      fullPath: '/study-group/$study-group-id/events'
      preLoaderRoute: typeof StudyGroupStudyGroupIdEventsRouteImport
      parentRoute: typeof StudyGroupStudyGroupIdRouteImport
    }
    '/study-group/$study-group-id/files': {
      id: '/study-group/$study-group-id/files'
      path: '/files'
      fullPath: '/study-group/$study-group-id/files'
      preLoaderRoute: typeof StudyGroupStudyGroupIdFilesRouteImport
      parentRoute: typeof StudyGroupStudyGroupIdRouteImport
    }
    '/study-group/$study-group-id/info': {
      id: '/study-group/$study-group-id/info'
      path: '/info'
      fullPath: '/study-group/$study-group-id/info'
      preLoaderRoute: typeof StudyGroupStudyGroupIdInfoRouteImport
      parentRoute: typeof StudyGroupStudyGroupIdRouteImport
    }
    '/study-group/$study-group-id/link-list': {
      id: '/study-group/$study-group-id/link-list'
      path: '/link-list'
      fullPath: '/study-group/$study-group-id/link-list'
      preLoaderRoute: typeof StudyGroupStudyGroupIdLinkListRouteImport
      parentRoute: typeof StudyGroupStudyGroupIdRouteImport
    }
    '/study-group/$study-group-id/stream': {
      id: '/study-group/$study-group-id/stream'
      path: '/stream'
      fullPath: '/study-group/$study-group-id/stream'
      preLoaderRoute: typeof StudyGroupStudyGroupIdStreamRouteImport
      parentRoute: typeof StudyGroupStudyGroupIdRouteImport
    }
    '/study-group/$study-group-id/': {
      id: '/study-group/$study-group-id/'
      path: '/'
      fullPath: '/study-group/$study-group-id/'
      preLoaderRoute: typeof StudyGroupStudyGroupIdIndexImport
      parentRoute: typeof StudyGroupStudyGroupIdRouteImport
    }
    '/study-group/$study-group-id/post/$post-id': {
      id: '/study-group/$study-group-id/post/$post-id'
      path: '/post/$post-id'
      fullPath: '/study-group/$study-group-id/post/$post-id'
      preLoaderRoute: typeof StudyGroupStudyGroupIdPostPostIdRouteImport
      parentRoute: typeof StudyGroupStudyGroupIdRouteImport
    }
  }
}

// Create and export the route tree

interface ChatRoomRouteRouteChildren {
  ChatRoomChatRoomIdRouteRoute: typeof ChatRoomChatRoomIdRouteRoute
  ChatRoomIndexRoute: typeof ChatRoomIndexRoute
}

const ChatRoomRouteRouteChildren: ChatRoomRouteRouteChildren = {
  ChatRoomChatRoomIdRouteRoute: ChatRoomChatRoomIdRouteRoute,
  ChatRoomIndexRoute: ChatRoomIndexRoute,
}

const ChatRoomRouteRouteWithChildren = ChatRoomRouteRoute._addFileChildren(
  ChatRoomRouteRouteChildren,
)

interface StudyGroupStudyGroupIdRouteRouteChildren {
  StudyGroupStudyGroupIdEventsRouteRoute: typeof StudyGroupStudyGroupIdEventsRouteRoute
  StudyGroupStudyGroupIdFilesRouteRoute: typeof StudyGroupStudyGroupIdFilesRouteRoute
  StudyGroupStudyGroupIdInfoRouteRoute: typeof StudyGroupStudyGroupIdInfoRouteRoute
  StudyGroupStudyGroupIdLinkListRouteRoute: typeof StudyGroupStudyGroupIdLinkListRouteRoute
  StudyGroupStudyGroupIdStreamRouteRoute: typeof StudyGroupStudyGroupIdStreamRouteRoute
  StudyGroupStudyGroupIdIndexRoute: typeof StudyGroupStudyGroupIdIndexRoute
  StudyGroupStudyGroupIdPostPostIdRouteRoute: typeof StudyGroupStudyGroupIdPostPostIdRouteRoute
}

const StudyGroupStudyGroupIdRouteRouteChildren: StudyGroupStudyGroupIdRouteRouteChildren =
  {
    StudyGroupStudyGroupIdEventsRouteRoute:
      StudyGroupStudyGroupIdEventsRouteRoute,
    StudyGroupStudyGroupIdFilesRouteRoute:
      StudyGroupStudyGroupIdFilesRouteRoute,
    StudyGroupStudyGroupIdInfoRouteRoute: StudyGroupStudyGroupIdInfoRouteRoute,
    StudyGroupStudyGroupIdLinkListRouteRoute:
      StudyGroupStudyGroupIdLinkListRouteRoute,
    StudyGroupStudyGroupIdStreamRouteRoute:
      StudyGroupStudyGroupIdStreamRouteRoute,
    StudyGroupStudyGroupIdIndexRoute: StudyGroupStudyGroupIdIndexRoute,
    StudyGroupStudyGroupIdPostPostIdRouteRoute:
      StudyGroupStudyGroupIdPostPostIdRouteRoute,
  }

const StudyGroupStudyGroupIdRouteRouteWithChildren =
  StudyGroupStudyGroupIdRouteRoute._addFileChildren(
    StudyGroupStudyGroupIdRouteRouteChildren,
  )

interface StudyGroupRouteRouteChildren {
  StudyGroupStudyGroupIdRouteRoute: typeof StudyGroupStudyGroupIdRouteRouteWithChildren
}

const StudyGroupRouteRouteChildren: StudyGroupRouteRouteChildren = {
  StudyGroupStudyGroupIdRouteRoute:
    StudyGroupStudyGroupIdRouteRouteWithChildren,
}

const StudyGroupRouteRouteWithChildren = StudyGroupRouteRoute._addFileChildren(
  StudyGroupRouteRouteChildren,
)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/calendar': typeof CalendarRouteRoute
  '/callback': typeof CallbackRouteRoute
  '/chat-room': typeof ChatRoomRouteRouteWithChildren
  '/favorites': typeof FavoritesRouteRoute
  '/logout': typeof LogoutRouteRoute
  '/study-group': typeof StudyGroupRouteRouteWithChildren
  '/test-login': typeof TestLoginRouteRoute
  '/not-found': typeof NotFoundRoute
  '/all-study-groups/$study-group-id': typeof AllStudyGroupsStudyGroupIdRouteRoute
  '/chat-room/$chat-room-id': typeof ChatRoomChatRoomIdRouteRoute
  '/event-search/$event-id': typeof EventSearchEventIdRouteRoute
  '/notification/entry': typeof NotificationEntryRouteRoute
  '/public-event/$event-code': typeof PublicEventEventCodeRouteRoute
  '/study-group/$study-group-id': typeof StudyGroupStudyGroupIdRouteRouteWithChildren
  '/user-profile/$user-id': typeof UserProfileUserIdRouteRoute
  '/settings/instant-notification': typeof SettingsInstantNotificationRoute
  '/settings/periodic-notification': typeof SettingsPeriodicNotificationRoute
  '/all-study-groups': typeof AllStudyGroupsIndexRoute
  '/chat-room/': typeof ChatRoomIndexRoute
  '/event-search': typeof EventSearchIndexRoute
  '/event-search/code/$event-code': typeof EventSearchCodeEventCodeRouteRoute
  '/study-group/$study-group-id/events': typeof StudyGroupStudyGroupIdEventsRouteRoute
  '/study-group/$study-group-id/files': typeof StudyGroupStudyGroupIdFilesRouteRoute
  '/study-group/$study-group-id/info': typeof StudyGroupStudyGroupIdInfoRouteRoute
  '/study-group/$study-group-id/link-list': typeof StudyGroupStudyGroupIdLinkListRouteRoute
  '/study-group/$study-group-id/stream': typeof StudyGroupStudyGroupIdStreamRouteRoute
  '/study-group/$study-group-id/': typeof StudyGroupStudyGroupIdIndexRoute
  '/study-group/$study-group-id/post/$post-id': typeof StudyGroupStudyGroupIdPostPostIdRouteRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/calendar': typeof CalendarRouteRoute
  '/callback': typeof CallbackRouteRoute
  '/favorites': typeof FavoritesRouteRoute
  '/logout': typeof LogoutRouteRoute
  '/study-group': typeof StudyGroupRouteRouteWithChildren
  '/test-login': typeof TestLoginRouteRoute
  '/not-found': typeof NotFoundRoute
  '/all-study-groups/$study-group-id': typeof AllStudyGroupsStudyGroupIdRouteRoute
  '/chat-room/$chat-room-id': typeof ChatRoomChatRoomIdRouteRoute
  '/event-search/$event-id': typeof EventSearchEventIdRouteRoute
  '/notification/entry': typeof NotificationEntryRouteRoute
  '/public-event/$event-code': typeof PublicEventEventCodeRouteRoute
  '/user-profile/$user-id': typeof UserProfileUserIdRouteRoute
  '/settings/instant-notification': typeof SettingsInstantNotificationRoute
  '/settings/periodic-notification': typeof SettingsPeriodicNotificationRoute
  '/all-study-groups': typeof AllStudyGroupsIndexRoute
  '/chat-room': typeof ChatRoomIndexRoute
  '/event-search': typeof EventSearchIndexRoute
  '/event-search/code/$event-code': typeof EventSearchCodeEventCodeRouteRoute
  '/study-group/$study-group-id/events': typeof StudyGroupStudyGroupIdEventsRouteRoute
  '/study-group/$study-group-id/files': typeof StudyGroupStudyGroupIdFilesRouteRoute
  '/study-group/$study-group-id/info': typeof StudyGroupStudyGroupIdInfoRouteRoute
  '/study-group/$study-group-id/link-list': typeof StudyGroupStudyGroupIdLinkListRouteRoute
  '/study-group/$study-group-id/stream': typeof StudyGroupStudyGroupIdStreamRouteRoute
  '/study-group/$study-group-id': typeof StudyGroupStudyGroupIdIndexRoute
  '/study-group/$study-group-id/post/$post-id': typeof StudyGroupStudyGroupIdPostPostIdRouteRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/calendar': typeof CalendarRouteRoute
  '/callback': typeof CallbackRouteRoute
  '/chat-room': typeof ChatRoomRouteRouteWithChildren
  '/favorites': typeof FavoritesRouteRoute
  '/logout': typeof LogoutRouteRoute
  '/study-group': typeof StudyGroupRouteRouteWithChildren
  '/test-login': typeof TestLoginRouteRoute
  '/not-found': typeof NotFoundRoute
  '/all-study-groups/$study-group-id': typeof AllStudyGroupsStudyGroupIdRouteRoute
  '/chat-room/$chat-room-id': typeof ChatRoomChatRoomIdRouteRoute
  '/event-search/$event-id': typeof EventSearchEventIdRouteRoute
  '/notification/entry': typeof NotificationEntryRouteRoute
  '/public-event/$event-code': typeof PublicEventEventCodeRouteRoute
  '/study-group/$study-group-id': typeof StudyGroupStudyGroupIdRouteRouteWithChildren
  '/user-profile/$user-id': typeof UserProfileUserIdRouteRoute
  '/settings/instant-notification': typeof SettingsInstantNotificationRoute
  '/settings/periodic-notification': typeof SettingsPeriodicNotificationRoute
  '/all-study-groups/': typeof AllStudyGroupsIndexRoute
  '/chat-room/': typeof ChatRoomIndexRoute
  '/event-search/': typeof EventSearchIndexRoute
  '/event-search/code/$event-code': typeof EventSearchCodeEventCodeRouteRoute
  '/study-group/$study-group-id/events': typeof StudyGroupStudyGroupIdEventsRouteRoute
  '/study-group/$study-group-id/files': typeof StudyGroupStudyGroupIdFilesRouteRoute
  '/study-group/$study-group-id/info': typeof StudyGroupStudyGroupIdInfoRouteRoute
  '/study-group/$study-group-id/link-list': typeof StudyGroupStudyGroupIdLinkListRouteRoute
  '/study-group/$study-group-id/stream': typeof StudyGroupStudyGroupIdStreamRouteRoute
  '/study-group/$study-group-id/': typeof StudyGroupStudyGroupIdIndexRoute
  '/study-group/$study-group-id/post/$post-id': typeof StudyGroupStudyGroupIdPostPostIdRouteRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/calendar'
    | '/callback'
    | '/chat-room'
    | '/favorites'
    | '/logout'
    | '/study-group'
    | '/test-login'
    | '/not-found'
    | '/all-study-groups/$study-group-id'
    | '/chat-room/$chat-room-id'
    | '/event-search/$event-id'
    | '/notification/entry'
    | '/public-event/$event-code'
    | '/study-group/$study-group-id'
    | '/user-profile/$user-id'
    | '/settings/instant-notification'
    | '/settings/periodic-notification'
    | '/all-study-groups'
    | '/chat-room/'
    | '/event-search'
    | '/event-search/code/$event-code'
    | '/study-group/$study-group-id/events'
    | '/study-group/$study-group-id/files'
    | '/study-group/$study-group-id/info'
    | '/study-group/$study-group-id/link-list'
    | '/study-group/$study-group-id/stream'
    | '/study-group/$study-group-id/'
    | '/study-group/$study-group-id/post/$post-id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/calendar'
    | '/callback'
    | '/favorites'
    | '/logout'
    | '/study-group'
    | '/test-login'
    | '/not-found'
    | '/all-study-groups/$study-group-id'
    | '/chat-room/$chat-room-id'
    | '/event-search/$event-id'
    | '/notification/entry'
    | '/public-event/$event-code'
    | '/user-profile/$user-id'
    | '/settings/instant-notification'
    | '/settings/periodic-notification'
    | '/all-study-groups'
    | '/chat-room'
    | '/event-search'
    | '/event-search/code/$event-code'
    | '/study-group/$study-group-id/events'
    | '/study-group/$study-group-id/files'
    | '/study-group/$study-group-id/info'
    | '/study-group/$study-group-id/link-list'
    | '/study-group/$study-group-id/stream'
    | '/study-group/$study-group-id'
    | '/study-group/$study-group-id/post/$post-id'
  id:
    | '__root__'
    | '/'
    | '/calendar'
    | '/callback'
    | '/chat-room'
    | '/favorites'
    | '/logout'
    | '/study-group'
    | '/test-login'
    | '/not-found'
    | '/all-study-groups/$study-group-id'
    | '/chat-room/$chat-room-id'
    | '/event-search/$event-id'
    | '/notification/entry'
    | '/public-event/$event-code'
    | '/study-group/$study-group-id'
    | '/user-profile/$user-id'
    | '/settings/instant-notification'
    | '/settings/periodic-notification'
    | '/all-study-groups/'
    | '/chat-room/'
    | '/event-search/'
    | '/event-search/code/$event-code'
    | '/study-group/$study-group-id/events'
    | '/study-group/$study-group-id/files'
    | '/study-group/$study-group-id/info'
    | '/study-group/$study-group-id/link-list'
    | '/study-group/$study-group-id/stream'
    | '/study-group/$study-group-id/'
    | '/study-group/$study-group-id/post/$post-id'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CalendarRouteRoute: typeof CalendarRouteRoute
  CallbackRouteRoute: typeof CallbackRouteRoute
  ChatRoomRouteRoute: typeof ChatRoomRouteRouteWithChildren
  FavoritesRouteRoute: typeof FavoritesRouteRoute
  LogoutRouteRoute: typeof LogoutRouteRoute
  StudyGroupRouteRoute: typeof StudyGroupRouteRouteWithChildren
  TestLoginRouteRoute: typeof TestLoginRouteRoute
  NotFoundRoute: typeof NotFoundRoute
  AllStudyGroupsStudyGroupIdRouteRoute: typeof AllStudyGroupsStudyGroupIdRouteRoute
  EventSearchEventIdRouteRoute: typeof EventSearchEventIdRouteRoute
  NotificationEntryRouteRoute: typeof NotificationEntryRouteRoute
  PublicEventEventCodeRouteRoute: typeof PublicEventEventCodeRouteRoute
  UserProfileUserIdRouteRoute: typeof UserProfileUserIdRouteRoute
  SettingsInstantNotificationRoute: typeof SettingsInstantNotificationRoute
  SettingsPeriodicNotificationRoute: typeof SettingsPeriodicNotificationRoute
  AllStudyGroupsIndexRoute: typeof AllStudyGroupsIndexRoute
  EventSearchIndexRoute: typeof EventSearchIndexRoute
  EventSearchCodeEventCodeRouteRoute: typeof EventSearchCodeEventCodeRouteRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CalendarRouteRoute: CalendarRouteRoute,
  CallbackRouteRoute: CallbackRouteRoute,
  ChatRoomRouteRoute: ChatRoomRouteRouteWithChildren,
  FavoritesRouteRoute: FavoritesRouteRoute,
  LogoutRouteRoute: LogoutRouteRoute,
  StudyGroupRouteRoute: StudyGroupRouteRouteWithChildren,
  TestLoginRouteRoute: TestLoginRouteRoute,
  NotFoundRoute: NotFoundRoute,
  AllStudyGroupsStudyGroupIdRouteRoute: AllStudyGroupsStudyGroupIdRouteRoute,
  EventSearchEventIdRouteRoute: EventSearchEventIdRouteRoute,
  NotificationEntryRouteRoute: NotificationEntryRouteRoute,
  PublicEventEventCodeRouteRoute: PublicEventEventCodeRouteRoute,
  UserProfileUserIdRouteRoute: UserProfileUserIdRouteRoute,
  SettingsInstantNotificationRoute: SettingsInstantNotificationRoute,
  SettingsPeriodicNotificationRoute: SettingsPeriodicNotificationRoute,
  AllStudyGroupsIndexRoute: AllStudyGroupsIndexRoute,
  EventSearchIndexRoute: EventSearchIndexRoute,
  EventSearchCodeEventCodeRouteRoute: EventSearchCodeEventCodeRouteRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/calendar",
        "/callback",
        "/chat-room",
        "/favorites",
        "/logout",
        "/study-group",
        "/test-login",
        "/not-found",
        "/all-study-groups/$study-group-id",
        "/event-search/$event-id",
        "/notification/entry",
        "/public-event/$event-code",
        "/user-profile/$user-id",
        "/settings/instant-notification",
        "/settings/periodic-notification",
        "/all-study-groups/",
        "/event-search/",
        "/event-search/code/$event-code"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/calendar": {
      "filePath": "calendar/route.tsx"
    },
    "/callback": {
      "filePath": "callback/route.tsx"
    },
    "/chat-room": {
      "filePath": "chat-room/route.tsx",
      "children": [
        "/chat-room/$chat-room-id",
        "/chat-room/"
      ]
    },
    "/favorites": {
      "filePath": "favorites/route.tsx"
    },
    "/logout": {
      "filePath": "logout/route.tsx"
    },
    "/study-group": {
      "filePath": "study-group/route.tsx",
      "children": [
        "/study-group/$study-group-id"
      ]
    },
    "/test-login": {
      "filePath": "test-login/route.tsx"
    },
    "/not-found": {
      "filePath": "not-found.tsx"
    },
    "/all-study-groups/$study-group-id": {
      "filePath": "all-study-groups/$study-group-id/route.tsx"
    },
    "/chat-room/$chat-room-id": {
      "filePath": "chat-room/$chat-room-id/route.tsx",
      "parent": "/chat-room"
    },
    "/event-search/$event-id": {
      "filePath": "event-search/$event-id/route.tsx"
    },
    "/notification/entry": {
      "filePath": "notification/entry/route.tsx"
    },
    "/public-event/$event-code": {
      "filePath": "public-event/$event-code/route.tsx"
    },
    "/study-group/$study-group-id": {
      "filePath": "study-group/$study-group-id/route.tsx",
      "parent": "/study-group",
      "children": [
        "/study-group/$study-group-id/events",
        "/study-group/$study-group-id/files",
        "/study-group/$study-group-id/info",
        "/study-group/$study-group-id/link-list",
        "/study-group/$study-group-id/stream",
        "/study-group/$study-group-id/",
        "/study-group/$study-group-id/post/$post-id"
      ]
    },
    "/user-profile/$user-id": {
      "filePath": "user-profile/$user-id/route.tsx"
    },
    "/settings/instant-notification": {
      "filePath": "settings/instant-notification.tsx"
    },
    "/settings/periodic-notification": {
      "filePath": "settings/periodic-notification.tsx"
    },
    "/all-study-groups/": {
      "filePath": "all-study-groups/index.tsx"
    },
    "/chat-room/": {
      "filePath": "chat-room/index.tsx",
      "parent": "/chat-room"
    },
    "/event-search/": {
      "filePath": "event-search/index.tsx"
    },
    "/event-search/code/$event-code": {
      "filePath": "event-search/code/$event-code/route.tsx"
    },
    "/study-group/$study-group-id/events": {
      "filePath": "study-group/$study-group-id/events/route.tsx",
      "parent": "/study-group/$study-group-id"
    },
    "/study-group/$study-group-id/files": {
      "filePath": "study-group/$study-group-id/files/route.tsx",
      "parent": "/study-group/$study-group-id"
    },
    "/study-group/$study-group-id/info": {
      "filePath": "study-group/$study-group-id/info/route.tsx",
      "parent": "/study-group/$study-group-id"
    },
    "/study-group/$study-group-id/link-list": {
      "filePath": "study-group/$study-group-id/link-list/route.tsx",
      "parent": "/study-group/$study-group-id"
    },
    "/study-group/$study-group-id/stream": {
      "filePath": "study-group/$study-group-id/stream/route.tsx",
      "parent": "/study-group/$study-group-id"
    },
    "/study-group/$study-group-id/": {
      "filePath": "study-group/$study-group-id/index.tsx",
      "parent": "/study-group/$study-group-id"
    },
    "/study-group/$study-group-id/post/$post-id": {
      "filePath": "study-group/$study-group-id/post/$post-id/route.tsx",
      "parent": "/study-group/$study-group-id"
    }
  }
}
ROUTE_MANIFEST_END */
